import { render, staticRenderFns } from "./servicesComponent.vue?vue&type=template&id=1d9bf1aa"
import script from "./servicesComponent.vue?vue&type=script&lang=js"
export * from "./servicesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports